import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/root-reducer';
import { getIdForIbjects } from '../utils/AppUtils';

/**
 * Merges discovery/API creator fields (`is_user_following`, `user_following`) with live
 * `audience.userFollowing` so Follow/Unfollow toggles immediately after follow/unfollow.
 */
export function useMergedCreatorFollowState(creator: any | null, creatorIdRaw: string | undefined) {
    const userFollowing = useSelector((s: RootState) => s.audience.userFollowing);
    const followingInProgress = useSelector((s: RootState) => s.audience.followingInProgress);

    return useMemo(() => {
        const resolvedCreatorId = creatorIdRaw ? String(getIdForIbjects(creatorIdRaw)) : '';
        const match = userFollowing.find(
            f => f?.following && resolvedCreatorId && String(getIdForIbjects(f.following._id)) === resolvedCreatorId,
        );
        const followDocId =
            match && match._id && match._id !== 'temporary'
                ? match._id
                : Array.isArray(creator?.user_following) && creator.user_following.length > 0
                ? creator.user_following[0]._id
                : null;
        const isFollowing = creator?.is_user_following === true || !!match;
        return { isFollowing, followDocId, followingInProgress, followMatch: match };
    }, [creator, creatorIdRaw, userFollowing, followingInProgress]);
}
